var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCause3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 231.29 233.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#012a66;}.cls-2{fill:#e2e2e2;}.cls-3{fill:#d81c03;}.cls-4{fill:#fff;}.cls-5{fill:#fcfcfc;stroke-width:2.9px;}.cls-11,.cls-5,.cls-8{stroke:#000;stroke-miterlimit:10;}.cls-6{fill:#00393a;}.cls-7{fill:#494949;}.cls-11,.cls-8{fill:none;}.cls-8{stroke-width:4px;}.cls-9{fill:#232323;}.cls-10{fill:#d84005;}.cls-11{stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9,175.79c-1.34-.13-13.94-.58-13.94-.58s1.77,3,8.66,7.3,5.48,5.8,6.9,4.27,7.33-13,7.33-13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48 164.43 36.88 182.24 24.09 173.13 38.99 145.85 49.6 152.2 48 164.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,158.52C12.22,158.11,0,155,0,155s1.08,3.35,6.91,9,4.11,6.83,5.83,5.64,9.93-11.1,9.93-11.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "36.54 151.93 21.86 166.96 11.32 155.32 31.7 131.85 40.72 140.33 36.54 151.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.7,68.48c-2.28,2-29.71,28.74-29.71,28.74l-11.1,11.42L83,106s-23.51-2.61-26.12-2-13.06,4.57-14.37,7.18S23.54,137.05,20.92,140c0,0,11.43,16,13.06,16s12.14,8.55,13.44,6.92,6.48-15.08,8.44-16.06c1-.49,13.34-2,25.45-3.41s24-2.67,24-2.67l54.07-11.22,18.28-24.16s7.51-14.69,6.2-19.92.42-11-.77-13.49-17.84-9-17.84-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.19,101.21a3.37,3.37,0,0,0-.38-.19,41.53,41.53,0,0,0-9.88-3.44,38.12,38.12,0,0,0-13,.52.72.72,0,0,0-.56.3c-.21.41.42.72.88.74,1.95.09,4-.27,5.81.39-.1.53-.77.67-1.31.69l-4.72.23a4.42,4.42,0,0,0-2.8.77.51.51,0,0,0-.21.31c-.06.34.39.51.73.55l5.54.66a4.32,4.32,0,0,1-3.36.56,5.27,5.27,0,0,0-3.43.31c-.29.19-.57.56-.39.86a.8.8,0,0,0,.6.28c2,.3,4.16.15,6,.82,2.21.77,4.55,1.26,6.78,2,1,.34,6.33,2.78,7.34,2s3.19-1,4.52-1.41a3.32,3.32,0,0,0,1.65-.74c.39-.5.18-1.18.28-1.74a15.43,15.43,0,0,1,.81-2.34,2.2,2.2,0,0,0,.17-.91A1.75,1.75,0,0,0,84.19,101.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.42,81.87c-1.64-1.31-14.37,1.63-16.33,3.27s-13.71,9.79-17.63,12.4-13.71,5.88-13.71,5.88-37.88-3.27-38.86-3.27-9.46,11.43-8.16,11.1S112,120.4,112,120.4s33.31.32,36.24-1.31,17-13.06,17-13.06,8.82-14.37,9.14-17.3S172.42,81.87,172.42,81.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M192.52,21.43s4.73-1.66,5.55-2.1a32.22,32.22,0,0,1,5.1-1.34c.61-.1,6.07-.95,6.38-.86s4.79.9,5.17,1,5.34,3.09,5.55,3.21,4,11.37,4.37,11.76,1,7.8,1,8.73-4.13,9.11-4.48,9.55a29.16,29.16,0,0,1-2.72,3.14c-.68.52-5.68,3.89-5.95,4.19s-5,3.9-5,3.9-15.68,6.41-16.36,6.76S183.07,72,183.07,72l-10.45,3.75-4.1,1.56-3.48.35-1.55.1-1.54-1L155.19,57.1s-3.66-17-3.77-17.93-.63-3.17-.65-3.75-.21-7.78-.19-8.13-.28-4.37,0-4.85,3.29-7.09,3.62-7.64,1.57-2.33,1.94-2.94,6.62-7.81,7.12-8.17a58.26,58.26,0,0,1,5.45-2.25A59.52,59.52,0,0,1,178.35,0c1.29,0,5.43,3.24,5.87,3.6s3.15,5.05,3.8,6,2.83,6.35,3.27,7.18.37,3.76.37,3.76l.29.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M189.89,53.68c-2.32.31-4.19.56-4.5.59-4.16.49-8.42-3.51-11.49-5.94a22.54,22.54,0,0,1-4.83-4.67,21.1,21.1,0,0,1-2.69-6.31c-.66-2.31-1.38-4.59-1.95-6.93,3.52-.22,7.25-.11,10.72-.65a3.78,3.78,0,0,1,1.11-.07c4.44.56,8.9,3,12.79,5.11a9.54,9.54,0,0,1,2.24,1.5A10,10,0,0,1,192.56,38c2.69,4.25,6.56,9.37,7.87,14.22C200.44,52.26,194.33,53.09,189.89,53.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M191.71,46.43c3.13-6.85-.37-11.08-7-13.3-5.16-1.74-11.87-1.17-13.45,5a11,11,0,0,0,.26,5.39,10,10,0,0,0,2.31,4.77A12.06,12.06,0,0,0,179,50.88c2.83.88,6,1.74,8.65.4a9.08,9.08,0,0,0,3.59-3.89Q191.49,46.93,191.71,46.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.71,30.15c0-.77-.49-7.51-.49-7.51l1.61.22.72,7.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.1 29.44 179.33 19.47 181.16 19.32 180.01 30.82 178.1 29.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.39 32.64 190.04 26.11 191.11 27.25 187.53 34.07 186.39 32.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.98 40.62 199.33 33.9 200.62 35.91 195 41.88 193.98 40.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.63,47.16c.51-.44,6.07-3.09,6.07-3.09l.63,1.87-5.89,3.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.77 40.09 163.51 42.63 164.03 44.68 167.92 41.56 166.77 40.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.96 46.82 166.91 52.37 168.45 53.53 172.53 47.17 170.96 46.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.91,50.62l-3,4.66s1.29,2,1.62,1.46,2.48-5,2.48-5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.17 54.23 181.73 59.22 183.85 59 185.39 54.27 183.17 54.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.89 53.68 189.13 58.91 191.21 57.92 191.72 53.74 189.89 53.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "55.2 156.68 70.03 163.7 66.36 167.53 52.33 160.67 55.2 156.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M163,123.07c-.72-1.08-71.78-11.49-73.57-11.49S74,112.66,72.9,113s-35.39,67.8-37.61,71,1.73,5,1.73,5S72.9,120.2,74.7,118.4s16.5-1.79,20.09-2.15,64.57,13.29,64.57,13.29l3.62-6.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M65.84,132.64S52,151.41,51,155s-8.64,18-9,21.89-4.47,5.53-6.75,7.16a12.28,12.28,0,0,1-6.86,2.29c-2,0-5.22-.33-5.22-.33s-1.63,3.59-1,5.55,5.22,4.25,5.22,4.25c2.5,1,5,1.87,7.49,2.85,4.86-7.31,8.39-16,12.56-23.74s8.38-15.45,12.67-23.13a2.08,2.08,0,0,1,.8-.91,2,2,0,0,1,1.57.18l8.17,3.32a6.61,6.61,0,0,0,2.49.65c1.59,0,2.91-1.13,4.22-2a12.34,12.34,0,0,1,3.13-1.6c3.65-1.19,9.4-.35,13.36-.34,5.23,0,10.46.09,15.69.16,4.88.06,9.77.15,14.65.19,1.46,0,4.72-.58,5.95-.11C121.15,147.89,65.84,132.64,65.84,132.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.86,152.17c6.23-2.22,13.12-.26,19.29,2.12a149.81,149.81,0,0,1,21.31,10.19c4.35,2.52,8.79,5.5,10.95,10.05,1.52,3.2,1.74,6.84,1.83,10.38q.16,6.36-.14,12.72a20.05,20.05,0,0,1-1.42,7.61,19.34,19.34,0,0,1-4.61,5.71c-9.55,8.93-21.4,16.14-34.43,17.2a55.53,55.53,0,0,1-10.15-.23c-11.52-1.19-23.71-5.5-29.82-15.34-4-6.37-4.81-14.17-5-21.67S57.12,175.48,61,169c3.49-5.84,9.4-9.93,15.72-12.45s13.1-3.63,19.82-4.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.38,176.55c-2.84,1.6-6.2,2-7.83,3.27-14.71,11.74,9,33,19.59,20.57l3.92-4.57,2-6.86a62.09,62.09,0,0,0-2-6.86C109.4,180.8,99.61,173.61,94.38,176.55Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 93,
    y1: 197.71,
    x2: 80.08,
    y2: 222.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 99.82,
    y1: 198.79,
    x2: 98.74,
    y2: 228.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 106.28,
    y1: 198.07,
    x2: 118.48,
    y2: 223.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 90.13,
    y1: 183,
    x2: 81.16,
    y2: 156.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 85.1,
    y1: 186.23,
    x2: 66.8,
    y2: 166.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 87.97,
    y1: 191.61,
    x2: 56.71,
    y2: 190.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 61.06,
    y1: 214.94,
    x2: 91.56,
    y2: 194.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 108.79,
    y1: 184.43,
    x2: 137.86,
    y2: 167.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 106.28,
    y1: 193.4,
    x2: 142.24,
    y2: 184.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 138.57,
    y1: 210.27,
    x2: 102.33,
    y2: 193.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.64,191.57c-.32-4.9-5.55-27.1-7.51-29.38-4-4.64-13.68-7.26-19.11-9.42-9.94-4-19.92-7.24-30.71-5.26-7.51,1.37-16.23,3.76-22.32,8.56-7.81,6.14-16.2,18.34-16.41,28.59-.28,13.5,4.2,28.05,14.83,37.16C73.11,229.27,88.53,233,99.92,233c12.13,0,23.69-6.29,33.11-13.43C142.74,212.24,146.47,203.9,145.64,191.57Zm-7.74,13.35c-8.91,14.74-25.18,20.59-41.67,20.92-9.35.19-15.38-4.82-23.17-9.14-8.23-4.56-11.11-12.49-13.78-21.06-2.16-6.91,1.58-17.41,4.42-23.67,11.52-25.35,46.39-18.9,65-6.52C140.94,173.63,145.5,192.34,137.9,204.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M213,59c3.48-.66,13.49-.44,14.36-.22s3.92,4.13,3.92,4.13L230.2,71s-8,2.83-10,2.83S200,76.65,199.3,77.3s-26.78,48.54-26.78,48.54-13.06,2.61-12.84,1.3,27.64-52.24,30-54.41,7.4-7.18,11.1-9.36S213,59,213,59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M94.71,174.27c-1-4.57-2.94-23.18-2-33s2.61-13.06,10.12-17,27.1-7.18,33.3-5.87,27.76,4.24,34.94,2.61,17.3-2.61,21.55-4.57,9.47-7.18,9.47-7.18-1,6.53-3.6,10.77a35.79,35.79,0,0,1-9.14,10.45c-3.59,2.61-6.85,6.2-11.42,6.53S156.42,140,156.42,140a15,15,0,0,0,9.79,1c5.55-1.31,14.69.65,20.24-3.6s9.47-6.53,11.1-8.16,1.31,2,0,3.59-6.2,5.88-8.48,8.49a46.47,46.47,0,0,1-9.47,8.16c-3.27,2-2.94,2.29-9.14,3.27s-11.76-.65-13.72.33,8.17,2.93,13.72,1.95,11.42-1.63,14.36-3.91,4.57-2,2,2.28a72.29,72.29,0,0,1-7.84,10.12c-2.28,2.61-16.65,5.55-22.85,7.51s-28.08-1-36.57,2.61-11.42,4.58-14.36,9.8S98,192.88,97,191.57,94.71,174.27,94.71,174.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.78,189.92a11.52,11.52,0,0,0-3.89-2.1c-3.43-1-4.46.59-7.59,1.63-1.08.36-3.59,4-3.59,4l-1.43,5,1.07,5.74c.48,2.54,9,4.39,11,4.26a10.27,10.27,0,0,0,8.25-5C48.16,198.87,45.57,193,41.78,189.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.61,202.23c2-2.78.34-7.32-2.38-9a5.33,5.33,0,0,0-1.45-.68,5.27,5.27,0,0,0-2.67.11,7.22,7.22,0,0,0-2.68,1.2,6.48,6.48,0,0,0-2.05,4.91,5.87,5.87,0,0,0,2.17,4.54,6.51,6.51,0,0,0,4.89,1.34A6.1,6.1,0,0,0,41.61,202.23Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 36.3,
    y1: 198.07,
    x2: 32.55,
    y2: 203.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 36.3,
    y1: 198.07,
    x2: 35.9,
    y2: 204.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 30.8,
    y1: 194,
    x2: 36.3,
    y2: 198.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 39.73,
    y1: 191.61,
    x2: 36.3,
    y2: 198.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 43.72,
    y1: 197.83,
    x2: 36.3,
    y2: 198.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 42.44,
    y1: 204.05,
    x2: 36.3,
    y2: 198.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 27.93,
    y1: 200.38,
    x2: 37.02,
    y2: 197.83
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCause3);
export default __webpack_public_path__ + "static/media/cause_3.665be4a096e6894d644b8a6122c6467c.svg";
export { ForwardRef as ReactComponent };